import OnlinePaymentModelBase from '../_generated/modelBases/online-payment-model-base';

export default class OnlinePaymentModel extends OnlinePaymentModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
